let lastSequence = 0;

export function findPanelSequence() {
  return ++lastSequence;
}
